import { useAuth } from "@/core/auth/hooks/useAuth";
import { useCurrentBusiness } from "@/features/business/hooks/useCurrentBusiness";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { LoadingSpinner } from "@/shared/components/ui/LoadingSpinner";
import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader, PageHeaderAction } from "@/shared/components/ui/PageHeader";
import { PlanSettings } from "../components/PlanSettings";
import { useSubscription } from "../hooks/subscriptionQueries";

export function PlanPage() {
  const { user } = useAuth();
  const { business, businessId, loading } = useCurrentBusiness();
  const owner = !!business && !!businessId && !!user && business.ownerId === user.id;
  const query = useSubscription(businessId, user?.id, owner);
  return (
    <Page>
      <PageHeader title="Plan" actions={owner && (
        <PageHeaderAction onClick={() => void query.refetch()} disabled={query.isFetching}>
          {query.isFetching ? "Refreshing..." : "Refresh"}
        </PageHeaderAction>
      )} />
      <PageContent>
        {loading ? (
          <LoadingSpinner message="Loading business..." />
        ) : owner && businessId && user ? (
          <PlanSettings key={`${businessId}:${user.id}`} businessId={businessId} userId={user.id} />
        ) : (
          <ErrorState message={business ? "Only the business owner can manage the plan." : "Select a business to manage the plan."} />
        )}
      </PageContent>
    </Page>
  );
}
